import CONFIG from '../../config';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material/dialog';
import { BackendService } from '../shared/backend.service';
import { AuthService } from '../shared/auth.service';
import { NotificationService } from '../notification/notification.service';
import { Utilities } from '../shared/utilities.service';
import { ConfirmModifyComponent } from '../profile/confirmmodify/confirmmodify.component';
import { AlertmessageService } from 'app/shared/alertmessage.service';

export interface SecurityQuestion {
    value: number;
    viewValue: string;
  }

@Component({
    selector: 'reset-questions',
    templateUrl: './reset-questions.template.html'
})
export class ResetQuestionsComponent extends Utilities implements OnInit {
    result:any;
    msg : any;
    id: string;
    updatedProfile: FormGroup;
    Password: FormControl;
   

    passwordStrength: number = 0;
    updatingPassword: boolean = false;
    passwordConfirmed: boolean = true;
    submitted: boolean = false;

    availableResetQuestions: any;
    selected_Q1: string = '';
    selected_Q2: string = '';
    securityquestions: SecurityQuestion[] = [
        {value: 1, viewValue: "What was your childhood nickname?"},
        {value: 2, viewValue: "What is the name of your favorite childhood friend?"},
        {value: 3, viewValue: "What was your dream job as a child?"},
        {value: 4, viewValue: "Where is your favorite place to travel?"},
        {value: 5, viewValue: "What primary school did you attend?"},
        {value: 6, viewValue: "In what village was your first full time job?"},
        {value: 7, viewValue: "Where did you meet your spouse/partner?"},
        {value: 8, viewValue: "What is the middle name of your oldest child?"},
        {value: 9, viewValue: "What are the last four digits of your driver's license number?"},
        {value: 10, viewValue: "What is the name of your favorite childhood friend?"},
        {value: 11, viewValue: "What is your maternal grandmother's maiden name?"}
    ];

    constructor(
        public _formBuilder: FormBuilder,
        public _router: Router,
        public location: Location,
        public notificationService: NotificationService,
        public authService: AuthService,
        public backendService: BackendService,
          public dialog: MatDialog,
          public alert:AlertmessageService,
    ) {
        super(location, notificationService, authService, backendService);
        this.setForm();
       
    }
    
    ngOnInit() {       
     this.getMyProfile();
     //this.getPasswordResetQuestions();
    }
    updateProfiledata2(updatedProfile) {
        const myThis = this;
        this.openDialog(updatedProfile);
    }
openDialog(updatedProfile: any): void {
        //localStorage.setItem('key', key);
        let dialogRef = this.dialog.open(ConfirmModifyComponent, {
            width: '50%',
            height: '30%',
            data: {  updatedProfile }
        });
        this._router.navigate(['/dashboard']);
        dialogRef.afterClosed().subscribe(result => {
            //this.GetExchangeData();
            //this.serviceInit();
        });
    }
    updateProfile(updatedProfile) {
        if(updatedProfile.ModifyPassword == ''){
            this.notificationService.showNotification({ message: 'Please Update Password', type: 'warning' });
        }
        console.log(updatedProfile.PwdResetQuestion1 ,updatedProfile.PwdResetQuestion2);
 if(updatedProfile.PwdResetQuestion1 == updatedProfile.PwdResetQuestion2){
            this.notificationService.showNotification({ message: 'Please Select Two different questions', type: 'warning' });
        }
        else{
        console.log(updatedProfile , this.passwordConfirmed);
        this.submitted = true;
        console.log(this.updatedProfile.valid , this.passwordConfirmed);
        if (this.updatedProfile.valid && this.passwordConfirmed) {
            this.backendService.postData(updatedProfile, `${CONFIG.profileApiUrlBase}/${this.authService.CustomerID}`)
                .subscribe(
                response => {
                   this.submitted = false;
                    if(!response['result'])
                    {
                        console.log("test alert");
                        this.alert.openConfirmationDialog(response['msg'],response['result']);
                        this._router.navigate(['/dashboard/account-setting']);
                    }
                    else
                    {
                       this.updateProfiledata2(updatedProfile);
                    //     this.openDialog(updatedProfile);
                    //     this.notificationService.showNotification({ message: response['msg'], type: 'success' });
                    // this.authService.logout();
                    }  
                },
                error => {
                    this.serverErrorOrTimeout(error);
                });
        } else {
            //validators handle this case
            console.log('error with form');
        }}
    }

    getMyProfile() {
       
        this.backendService.getData(`${CONFIG.profileApiUrlBase}/${this.authService.CustomerID}`)
            .subscribe(response => {
                console.log("getMyProfile method");
                if(!response) {
                    this.notificationService.showNotification({ timer: 5000, message: response['msg'], type: 'error', closeable: false });
                }

                //set the id - we use this to identify the profile when updating below instead of the 
                //email because the email can be changed- this cannot
                //this.id = profileData.id;
                
                this.updatedProfile.controls['ModifyPassword'].valueChanges
                    .debounceTime(200)
                    .subscribe((value) => {
                        this.passwordConfirmed = value === '';
                        this.updatingPassword = value !== '';
                    });

                this.updatedProfile.controls['ConfirmPassword'].valueChanges
                    .subscribe((value) => {
                        this.passwordConfirmed = this.updatedProfile.controls['ModifyPassword'].value === value;
                    });
             },
            error => {
                this.serverErrorOrTimeout(error);
            });
            }
            // getPasswordResetQuestions() {
            //     this.backendService.getData(CONFIG.getsecurityquestionsApiUrlBase)
            //         .subscribe(questions => {
            //             this.availableResetQuestions = questions;
            //         }, error => {
            //             this.serverErrorOrTimeout(error);
            //         });
            // }
        
            // setSecurityQuestions(newInfo) {
            //     this.submitted = true;
        
            //     if(this.updatedProfile.valid) {
            //         this.backendService.putData(newInfo, `${CONFIG.profileApiUrlBase}/updateprofilesecurityquestions`)
            //             .subscribe(response => {
            //                 if(response) {
            //                     //finish login process
            //                     this.submitted = false;
            //                     this.authService.isLoggedIn = true;
        
            //                     //remove the 'partiallogin' session variable that prevented further nav on reload
            //                     sessionStorage.removeItem('partial_login');
        
            //                     //hide form
            //               //      this._loginService.resetQuestionsSet = true;
        
            //                     this.notificationService.showNotification({ message: response['msg'], type: 'success' });
            //                     this._router.navigate(['/main']);
            //                 } else {
            //                     this.notificationService.showNotification({ message: response['msg'], type: 'error' });
            //                 }
                            
            //             }, error => {
            //                 this.serverErrorOrTimeout(error);
            //             });
            //     } else {
            //         //validators should handle this branch
            //     }
            // }
        
            cancel() {
               // this._loginService.resetQuestionsSet = true;
                this.authService.logout();
            }
        
            
    setForm() {
        this.updatedProfile = this._formBuilder.group({
            'Password': ['', Validators.minLength(3)],
            'ModifyPassword': ['', Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$')],
            'ConfirmPassword': ['', Validators.required],
            'PwdResetQuestion1': ['', Validators.required],
            'PwdResetQuestion2': ['', Validators.required],
            'PwdResetAnswer1': ['', Validators.required],
            'PwdResetAnswer2': ['', Validators.required]
        });
    }
}
